import React from 'react'
import Headerbar  from "./components/common/Headerbar";
import Titlebar  from "./components/common/Titlebar";
import PaymentRequestHistoryGrid from './components/payment_approval/PaymentRequestHistoryGrid';

function PaymentRequestHistory() {
  return (
    <><Headerbar /><Titlebar name="Payment Request History" /><PaymentRequestHistoryGrid/></>
  )
}

export default PaymentRequestHistory